/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import JobTable from './JobTable';

function TechnicianCard({ tech, open, onToggle, bestMoves, selectedOfscNr, onSelectJob }) {
  const otBadge = tech.overtimeMinutes > 0
    ? <span className="badge badge-ot">+{Math.round(tech.overtimeMinutes)}dk OT</span>
    : null;
  const violBadge = tech.etaViolationCount > 0
    ? <span className="badge badge-viol">{tech.etaViolationCount} ihlal</span>
    : null;
  return (
    <div className="tech-card">
      <div className="tech-head" onClick={onToggle}>
        <div>
          <span className="caret">{open ? '▼' : '▶'}</span>
          <span className="tech-name">{tech.techName}</span>
        </div>
        <div className="tech-meta">
          <span>{tech.jobCount} randevu · {tech.servicePaperCount} fiş</span>
          <span>{tech.totalKm.toFixed(1)} km</span>
          {otBadge}
          {violBadge}
        </div>
      </div>
      <div className={`tech-body${open ? ' open' : ''}`}>
        {open && (
          <JobTable
            jobs={tech.jobs}
            selectable
            showStatus={false}
            bestMoves={bestMoves}
            selectedOfscNr={selectedOfscNr}
            onSelectJob={onSelectJob}
          />
        )}
      </div>
    </div>
  );
}

// Teknisyenlerin gün panosu (sol panel). Her kart tıklanınca genişler/kapanır; seçili
// randevu değiştiğinde ilgili satırı görünüme kaydırır (eski vanilla JS'teki
// selectJob()'un scrollIntoView davranışının React karşılığı).
export default function TechnicianList({
  technicians,
  bestMoves,
  selectedOfscNr,
  onSelectJob,
  onToggleTechnician,
}) {
  const [openTechCode, setOpenTechCode] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (selectedOfscNr == null || !containerRef.current) return;
    const row = containerRef.current.querySelector('tr.job-row.selected');
    row?.scrollIntoView({ block: 'nearest' });
  }, [selectedOfscNr]);

  function toggle(techCode) {
    const willOpen = openTechCode !== techCode;
    onToggleTechnician?.(techCode, willOpen);
    setOpenTechCode(willOpen ? techCode : null);
  }

  if (!technicians.length) {
    return <div className="empty">Veri bulunamadı.</div>;
  }

  return (
    <div ref={containerRef}>
      {technicians.map(tech => (
        <TechnicianCard
          key={tech.techCode}
          tech={tech}
          open={openTechCode === tech.techCode}
          onToggle={() => toggle(tech.techCode)}
          bestMoves={bestMoves}
          selectedOfscNr={selectedOfscNr}
          onSelectJob={onSelectJob}
        />
      ))}
    </div>
  );
}
